import * as React from "react";
import { Editor } from "@/interfaces";
import { UsersService } from "@/services";
import { Table } from "@/components/ui";
import UserTable from "../../UserTable";

const EditorsListFC: React.FC = () => {
  return (
    <UserTable
      hideSearch
      queryFunction={query => UsersService.getEditors([], query.page, query.size)}
      headers={[{ title: "Name" }, { title: "Email" }]}
      renderRow={(editor: Editor) => (
        <>
          <Table.Cell className="py-3">
            {editor.firstName} {editor.lastName}
          </Table.Cell>
          <Table.Cell className="py-3">{editor.email}</Table.Cell>
        </>
      )}
    />
  );
};

export const EditorsList = EditorsListFC;
